import { useContext, useMemo, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

import { Context } from "../Provider";
import { theme } from "../../../theme";
import { updateFtmProfileImage } from "../service";
import { commonSwal } from "../../../components/swalAlert/swalAlert";
import ProfileImageView from "../../components/profileImageView/ProfileImageView";
import { truncateText } from "../../../utils";

const FtmIdentification = () => {
    const { ftm_id } = useParams();
    const { identificationDetails = {}, dispatch } = useContext(Context);

    const [openProfileView, setOpenProfileView] = useState(false);

    const handleOpenProfileView = () => setOpenProfileView(true);
    const handleCloseProfileView = () => setOpenProfileView(false);

    const {
        ftm_street_address,
        ftm_place,
        ftm_postcode,
        ftm_forename,
        ftm_surname,
        ftm_profile_image_path,
        ftm_profile_image_approved,
    } = identificationDetails;

    const fullAddress = useMemo(
        () => [ftm_street_address, ftm_place, ftm_postcode].filter(Boolean).join(", "),
        [ftm_street_address, ftm_place, ftm_postcode]
    );

    const fullName = useMemo(
        () => [ftm_forename, ftm_surname].filter(Boolean).join(" "),
        [ftm_forename, ftm_surname]
    );

    const approveProfileImage = useCallback(() => {
        commonSwal({
            notificationType: "APPROVE_FTM_PROFILE_IMAGE",
            preConfirm: async () => updateFtmProfileImage(ftm_id),
            isConfirmed: (result) => {
                if (result?.isConfirmed && result?.value?.status === "Success") {
                    dispatch({ type: "INCREMENT_REFRESH_COUNT" });
                    toast.success(result.value.message);
                }
            },
        });
    }, [ftm_id, dispatch]);

    return (
        <div className="card card-body mb-3" id="profile">
            <div className="row justify-content-center align-items-center">
                <div className="col-sm-auto col-4">
                    <div className="avatar avatar-xl position-relative">
                        <img
                            src={ftm_profile_image_path || "/assets/img/lock_user.png"}
                            alt={fullName || "profile"}
                            className="avatar avatar-xl border-radius-lg w-100 cursor-pointer"
                            onClick={handleOpenProfileView}
                        />

                        <ProfileImageView show={openProfileView} closeModal={handleCloseProfileView} imagePath={ftm_profile_image_path || "/assets/img/lock_user.png"}/>
                    </div>
                </div>

                <div className="col-sm-auto col-8 my-auto">
                    <div className="h-100">
                        <h5 className="mb-1 font-weight-bolder">
                            {fullName}
                            {ftm_profile_image_approved === 1 && (
                                <i className={`material-icons opacity-10 text-${theme.main} ms-2`}>verified</i>
                            )}
                        </h5>
                        <p className="mb-0 font-weight-normal text-sm">{truncateText(fullAddress, 50)}</p>
                    </div>
                </div>

                <div className="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">
                    {ftm_profile_image_approved !== 1 && (
                        <button
                            className={`btn bg-gradient-${theme.main} mb-0 btn-sm`}
                            onClick={approveProfileImage}
                        >
                            <i className="material-icons text-sm">how_to_reg</i>&nbsp;Approve Image
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FtmIdentification;